import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M2 10.222V17M2 15.87h12.429a2.26 2.26 0 0 0-2.26-2.259H9.344a2.259 2.259 0 0 0-2.26-2.26H2M6.519 13.611h2.825\" stroke=\"#0F6378\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><g clip-path=\"url(#a)\" stroke=\"#0F6378\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7.553 9.187 7.341-7.34-7.341 7.34Z\"></path><path d=\"M13.765 9.187a1.13 1.13 0 1 0 0-2.259 1.13 1.13 0 0 0 0 2.259Z\" fill=\"#0F6378\"></path><path d=\"M8.682 4.105a1.13 1.13 0 1 0 0-2.258 1.13 1.13 0 0 0 0 2.258Z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(6.706 1)\" d=\"M0 0h9.035v9.034H0z\"></path></clipPath></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }